import { closeRamsRecordModal } from '../State/ramsRecordModal'
import fetchProject from '../Services/fetchProject'

export default (shouldReload = false) => (dispatch) => {
  
  dispatch(closeRamsRecordModal())

  if (shouldReload === true) dispatch(fetchProject())
  
}